import React from "react";
import { Cached } from "@mui/icons-material";

export default function Loading() {
  return (
    <div className="loading">
      <Cached className="loading-icon" />
      <p>Loading..</p>
    </div>
  );
}
